import { Controller } from "@hotwired/stimulus";

class IdentityVerificationStatusController extends Controller {
  static values = {
    statusUrl: String
  }

  connect() {
    this.checkTimes = [3000, 10000, 20000]; // 3秒後、10秒後、20秒後の3回のみ
    this.checkIndex = 0;

    // 初回チェックを3秒後に実行
    setTimeout(() => this.checkStatus(), this.checkTimes[0]);
  }

  checkStatus() {
    fetch(this.statusUrlValue, {
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.pending_approval) {
        // ステータスがpending_approvalに変わったらページをリロード
        window.location.reload();
      } else if (data.in_progress) {
        this.checkIndex++;
        if (this.checkIndex < this.checkTimes.length) {
          // 次回チェックをスケジュール
          const nextDelay = this.checkTimes[this.checkIndex] - this.checkTimes[this.checkIndex - 1];
          setTimeout(() => this.checkStatus(), nextDelay);
        } else {
          // 3回チェックしても完了していない場合
          this.showManualReloadMessage();
        }
      }
    })
    .catch(error => {
      console.error('Status check error:', error);
      // エラーが発生した場合も次回チェックを試みる
      this.checkIndex++;
      if (this.checkIndex < this.checkTimes.length) {
        const nextDelay = this.checkTimes[this.checkIndex] - this.checkTimes[this.checkIndex - 1];
        setTimeout(() => this.checkStatus(), nextDelay);
      }
    });
  }

  showManualReloadMessage() {
    const processingMessage = this.element.querySelector('#processing-message');
    const delayedMessage = this.element.querySelector('#delayed-message');

    if (processingMessage) {
      processingMessage.classList.add('identity-verification-complete__processing-container--hidden');
    }
    if (delayedMessage) {
      delayedMessage.classList.remove('identity-verification-complete__processing-container--hidden');
    }
  }

  reload() {
    window.location.reload();
  }
}

// Registered in customer.js
export { IdentityVerificationStatusController };
